const SizeUtils = {
  transfSize (size) {
    if (size < 1) {
      return Math.round((size * 1024) * 100) / 100 + ' KB'
    } else if (size > 1024 && size < 1048576) {
      return Math.round((size / 1024) * 100) / 100 + ' GB'
    } else if (size > 1048576) {
      return Math.round((size / 1048576) * 100) / 100 + ' T'
    } else {
      return Math.round(size * 100) / 100 + ' MB'
    }
  }
}
export default SizeUtils



// WEBPACK FOOTER //
// ./src/utils/sizeUtils.js